<template>
    <Modal :isOpen="opened" @close="discard">
        <GdprManager>
            <aside class="gdpr" slot-scope="{ manager, groups, toggleManager }">
                <h3 class="gdpr__title primary">
                    Règlement sur la Gestion et la Protection des Données personnelles

					<div>
						<h5 class="primary gdpr__able" @click="disableAll">Tout refuser</h5>
						<h5 class="primary gdpr__able" @click="enableAll">Tout accepter</h5>

						<LmdtSwitch
							class="gdpr__switch"
							theme="lmdt"
							color="primary"
							:type-bold="true"
							:value="manager.enabled"
							@input="toggleManager"/>
					</div>
                </h3>

                <GdprGroup v-for="group in groups" :key="group.name" :group="group">
                    <section class="gdpr__group" slot-scope="{ guards, toggleGroup }">
                        <dl class="gdpr__info">
                            <dt class="gdpr__name">
                                {{ group.name }}
                            </dt>

                            <dd class="gdpr__description">
                                {{ group.description }}
                            </dd>

                            <LmdtSwitch
                                v-if="guards.length > 1"
                                class="gdpr__switch"
                                theme="lmdt"
                                color="primary"
                                :type-bold="true"
                                :disabled="group.required"
                                :value="group.enabled"
                                @input="toggleGroup"/>
                        </dl>

                        <GdprGuard v-for="guard in guards" :key="guard.name" :guard="guard">
                            <article class="gdpr__item" slot-scope="{ toggleGuard }">
                                <dl class="gdpr__info">
                                    <dt class="gdpr__name">
                                        {{ guard.name }}
                                        <span class="gdpr__storage" v-if="$gdprStorageToString(guard.storage)">
                                            Situé dans : {{ $gdprStorageToString(guard.storage) }}
                                        </span>
                                    </dt>

                                    <dd class="gdpr__description">{{ guard.description }}</dd>

                                    <LmdtSwitch
                                        class="gdpr__switch"
                                        theme="lmdt"
                                        color="primary"
                                        :type-bold="true"
                                        :disabled="guard.required"
                                        :value="guard.enabled"
                                        @input="toggleGuard"/>
                                </dl>
                            </article>
                        </GdprGuard>
                    </section>
                </GdprGroup>

                <div class="gdpr__buttons">
                    <LmdtButton classes="gdpr__discard" @click="discard">
                        Annuler
                    </LmdtButton>

                    <LmdtButton classes="gdpr__save" @click="save">
                        Sauvegarder
                    </LmdtButton>
                </div>
            </aside>
        </GdprManager>
    </Modal>
</template>

<script>
	import VueTypes from "vue-types"
	import { GdprManager, GdprGroup, GdprGuard } from "vue-gdpr-guard"
	import Modal from "@/components/Modal"
	import LmdtSwitch from "@/components/Switch"
	import LmdtButton from "@/components/LmdtButton"
	import Card from "@/components/Card"

	export default {
		components: {
			GdprManager,
			GdprGroup,
			GdprGuard,
			Modal,
			LmdtSwitch,
			LmdtButton,
			Card,
		},
		props: {
			opened: VueTypes.bool.def(false),
		},
		mounted(){
			if(!this.$gdpr_serde.exists())
				this.$gdpr.enable("_ga");
		},
		methods: {
			enableAll(){
				this.$gdpr.enable();
			},
			disableAll(){
				this.$gdpr.disable();
			},
			close(){
				this.$ga.load(this); // wake google analytics on close
				this.$emit("close");
			},
			discard(){
				const didStore = this.$gdpr_serde.storeIfNotExists(this.$gdpr.raw());

				if(didStore)
					this.$toast.info("Nous avons bien annulé vos modifications");
				else
					this.$toast.error("Nous n'avons pas réussi à annuler vos modifications")

				this.close();
			},
			save(){
				const didStore = this.$gdpr_serde.store(this.$gdpr.raw());

                if(didStore)
                    this.$toast.success("Nous avons sauvegardé vos préférences");
                else
                    this.$toast.error("Nous n'avons pas réussi à sauvegarder vos préférences");

				this.close();
			},
		},
	}
</script>

<style lang="scss">
	@use "~@scss/components/Gdpr" as *;
</style>
